const DEFAULT_KZ_REGION = 'kazakhstan';
const DEFAULT_RU_REGION = 'moscow';

export function getRegion(hostname: string, domain: string) {
  const allFsStands = new Array(20).map((_, index) => `fs${index}`);
  const definetlyNotARegion = [
    ...allFsStands,
    'ux',
    'aem-pprod',
    'aem',
    'localhost',
    'leroymerlin',
    'mf',
    'mf-cft-stage',
    'mf-cft',
    'mf-landings',
    'aem-hf',
    'dispatcher-07-yandex',
    'internal-pprod',
    'internal',
    'lemonlid',
    'lemanapro',
    'triffle-p0501',
  ];

  if (
    ['adeo.com', 'leroymerlin.ru', 'localhost', 'lmru.tech', 'lemonlid.ru', 'lemanapro.ru'].some(
      matchingDomain => domain === matchingDomain
    )
  ) {
    const [maybeRegion] = hostname.split('.');

    const isFeatureStand = maybeRegion.search(/triffle[-\w]{0,}-[0-9]+/);

    if (!definetlyNotARegion.some(prefix => maybeRegion.startsWith(prefix)) && isFeatureStand === -1) {
      return maybeRegion;
    }
  }

  // TODO temporary solution
  if (domain.endsWith('.kz') || domain.endsWith('lmkz.tech') || domain.startsWith('kazakhstan.')) {
    return DEFAULT_KZ_REGION;
  }

  return DEFAULT_RU_REGION;
}
